import { Button, Box } from 'components/primitives'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { contractDefinition } from 'utils/collections' // Import contract definitions

export const DownloadAssetButton = ({ token }: any) => {
  let downloadPath

  // Find the collection for the token's contract address
  const collection = contractDefinition.find(
    (c) => c.contract.toLowerCase() === token?.token.contract?.toLowerCase()
  )

  // Allowed collections (some collections don't have asset packs)
  const allowedCollections = ['souls', 'ponies', 'warriors', 'wizards']

  // Construct the downloadPath if the collection is found and is allowed
  if (
    collection &&
    allowedCollections.includes(collection.name.toLowerCase())
  ) {
    downloadPath = `/${collection.name.toLowerCase()}/${
      token?.token.tokenId
    }.zip`
  }

  // Render button only if downloadPath is available
  if (downloadPath) {
    return (
      <Button color="gray3" size="xs">
        <a
          href={`https://www.forgottenrunes.com/api/art${downloadPath}`}
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }} // Ensuring link styles match button
        >
          <FontAwesomeIcon icon={faDownload} width={16} height={16} />
          {/* Optional: Add text here if you want a label next to the icon */}
        </a>
      </Button>
    )
  }

  // Return null or some fallback UI if no download path is available
  return null
}
